import { render, staticRenderFns } from "./groupDetail.vue?vue&type=template&id=67ba4a2a&scoped=true&"
import script from "./groupDetail.vue?vue&type=script&lang=js&"
export * from "./groupDetail.vue?vue&type=script&lang=js&"
import style0 from "./groupDetail.vue?vue&type=style&index=0&id=67ba4a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba4a2a",
  null
  
)

export default component.exports